export default {
  title: 'Como funcionam as taxas de processamento',
  how_it_works:
    'O Stripe cobra a sua taxa à sua plataforma por cada pagamento online efetuado nos seus restaurantes. A taxa de processamento que definir é o que o restaurante paga por esse pagamento. Se for superior à taxa do Stripe, fica com a diferença como margem. Se for inferior, ou se não definir nenhuma, paga a diferença do seu bolso.',
  stripe_rates_link: 'Ver as taxas padrão do Stripe',
  example: {
    intro:
      'Exemplo: uma encomenda de {{total}} paga com cartão. O Stripe cobra à sua plataforma {{stripe_fee}} ({{stripe_rate}}).',
    above: 'A sua taxa {{rate}}: o restaurante paga {{fee}} e você fica com {{difference}}.',
    below: 'A sua taxa {{rate}}: o restaurante paga {{fee}} e você paga a diferença de {{difference}}.',
    none: 'Sem taxa (margem de 0%): o restaurante não paga nada e você paga na totalidade os {{stripe_fee}}.',
    disclaimer:
      'A taxa do Stripe aqui indicada é a sua taxa padrão para cartões no EEE, a título ilustrativo. A taxa real depende do cartão, do respetivo país e do seu preço no Stripe.',
  },
};
